import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_INSULATION_FAQS } from "@/components/landing/lp-commercial-insulation";

import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialInsulationPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-insulation"),
  "LpCommercialInsulation",
);

const PATH = "/commercial-insulation";
const TITLE = "Insulation Retrofit Programmes | Councils, HAs & Frameworks | CRS Energy";
const DESCRIPTION =
 "PAS 2030 insulation programmes for councils, housing associations and frameworks, cavity, loft and IWI with suitability inspection, trained installers and conformity documentation.";
const BREADCRUMB_NAME = "Insulation Retrofit Programmes";

export const Route = createFileRoute("/commercial-insulation")({
 head: () => ({
 ...pageSeo({
 path: PATH,
 title: TITLE,
 description: DESCRIPTION,
 ogType: "article",
 }),
 scripts: [
 serviceJsonLdScript({
 name: BREADCRUMB_NAME,
 description: DESCRIPTION,
 serviceType: "Insulation Retrofit Programmes",
 url: `${SITE.url}${PATH}`,
 }),
 {
 type: "application/ld+json",
 children: JSON.stringify({
 "@context": "https://schema.org",
 "@type": "FAQPage",
 mainEntity: COMMERCIAL_INSULATION_FAQS.map((f) => ({
 "@type": "Question",
 name: f.question,
 acceptedAnswer: { "@type": "Answer", text: f.answer },
 })),
 }),
 },
 breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
 ],
 }),
 component: LpCommercialInsulationPage,
});
